  import { Swiper, SwiperSlide } from "swiper/react";
  import "swiper/css";
  import "swiper/css/pagination";
  import { Pagination, Autoplay } from "swiper/modules";


  const reviews = [
    {
      name: "~ Natalia",
      stars: 5,
      text: "Serdecznie polecam. Organizowaliśmy w restauracji komunię córki. Jedzenie bardzo dobre, wszystkiego było pod dostatkiem, obsługa cały czas interesowała się tym co się dzieje na sali. Jeśli miałabym robić następną imprezę to ponownie wybrałabym restaurację Magiczną.",
    },
    {
      name: "~ Katarzyna",
      stars: 5,
      text: "Najlepsza zabawa karnawałowa, na jakiej byliśmy! Świetna organizacja, fantastyczna muzyka i wspaniała atmosfera. Wszystko dopięte na ostatni guzik – pyszne jedzenie, profesjonalna obsługa i niesamowita energia. Bawiliśmy się do białego rana i na pewno wrócimy za rok! Gorąco polecamy!",
    },
    {
      name: "~ Beata ",
      stars: 5,
      text: "Polecam restauracje na zorganizowanie imprezy. To była nasza kolejna impreza w tym lokalu. Po raz kolejny jesteśmy bardzo zadowoleni. Jedzenie pyszne, duża przestrzeń ( jeśli ktoś organizuje imprezę z tańcami). Fajny klimat sali. Przede wszystkim bardzo dobry kontakt z właścicielką. W każdej kwestii można się dogadać. Duża życzliwość i elastyczność. Nastawienie na zadowolenie klienta. Gorąco polecam i dziękuję.",
    },
    {
      name: "~ Adam",
      stars: 5,
      text: "Piękne miejsce na zorganizowanie rodzinej imprezy. Pyszne jedzenie cały czas na stołach czysto kelnerzy Dbają by nic nie brakło wspaniały wystrój wnętrza Obsługa bardzo miła Jedyny minus to trochę mały parking",
    },
      {
      name: "~ Krzysztof",
      stars: 5,
      text: "Bardzo dużo dobrego jadła w przystępnej. Restauracja na uboczu, więc nie ma problemu ze znalezieniem wolnego stolika.",
    },
    {
      name: "~ Andrzej",
      stars: 5,
      text: "Polecam,zabawa karnawałowa super, obsługa suuuper,do zobaczenia.",
    },
    {
      name: "~ Patrycja",
      stars: 5,
      text: "Serdecznie polecam jako miejsce do zorganizowania imprezy urodzinowej itp. Jedzenie przepyszne, nietypowe połączenia niektórych smaków a zaskakująco dobre. Obsługa (Pani Ewa) na medal.",
    },
    {
      name: "~ stylehunter",
      stars: 5,
      text: "Od lat nasza ulubiona restauracja z przepysznym jedzeniem, super klimatem i fantastyczną obsługą z Panią Dorotką na czele. Od lat wszystkie rodzinne uroczystości tylko z Magiczną. Z serca polecam!!!",
    },
  ];

  export default function ReviewsSection() {

    
    return (
      <section className="bg-[#fff] py-20 px-4 -mt-5 md:-mt-[220px]" id="opinie">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-heading text-dark mb-2">Opinie</h2>
          <p className="text-dark/70 font-body mb-12">
            Nasi klienci są naszą najlepszą wizytówką – sprawdź, co mówią o nas po swoich przyjęciach.
          </p>

          <div className="relative">
<Swiper
  modules={[Pagination, Autoplay]}
  autoplay={{
    delay: 5000,
    disableOnInteraction: false,
  }}
  pagination={{
    clickable: true,
    el: ".swiper-pagination-custom",
  }}
  spaceBetween={30}
  slidesPerView={1}
  breakpoints={{
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
  }}
>
              {reviews.map(({ name, stars, text }, index) => (
                <SwiperSlide key={index}>
                  <div className="bg-primary text-white p-8 shadow-lg rounded-[24px] flex flex-col justify-between min-h-[450px] h-full">
                    <div>
                      <div className="text-accent mb-2 text-2xl">
                        {"★".repeat(stars)}{"☆".repeat(5 - stars)}
                      </div>
                      <p className="italic mb-4">“{text}”</p>
                    </div>
                    <div className="mt-6">
                      <div className="font-bold">{name}</div>
                      <div className="text-sm text-white/70">Gość Restauracji</div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Kropki nawigacyjne */}
            <div className="swiper-pagination-custom mt-8" />
          </div>

          {/* Przycisk do opinii Google */}
          <div className="mt-12">
            <a
              href="https://www.google.com/search?q=Restauracja+Magiczna+Tychy&hl=pl#lrd=0x4716c6bb690b4c33:0x4ccf8c2e6b8a3bde,1,,,"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-accent text-white px-6 py-3 rounded-full font-body shadow hover:bg-primary transition"
            >
              Zobacz więcej opinii w Google
            </a>
          </div>
        </div>
      </section>
    );
  }
